<div class="task-list-patient-info-wrapper">
  <div class="header-container">
    <div class="patient-info-section">
      <div class="patient-title">
        {{ 'COMPONENT.PAGE_ORGA.tasks' | translate }} -
        <strong>{{ patientInfo.lastName }}, {{ patientInfo.firstName }}</strong>
      </div>
      <div class="patient-details"></div>
    </div>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
